import { render, staticRenderFns } from "./AddVendorPage.vue?vue&type=template&id=28859344&scoped=true&"
import script from "./AddVendorPage.vue?vue&type=script&lang=js&"
export * from "./AddVendorPage.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorPage.vue?vue&type=style&index=0&id=28859344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28859344",
  null
  
)

export default component.exports